export default "__VITE_ASSET__Bo00PGLq__"